/* Build-time settings. The API is same-origin by default: Vite proxies /api in development and
   nginx does in production, so VITE_API_URL is only needed when the API lives elsewhere. */
export const env = {
  apiUrl: import.meta.env.VITE_API_URL?.replace(/\/$/, "") ?? "",
} as const;
